import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Dialog, styled, Box, Typography, IconButton } from '@mui/material';

import { CustomButton } from '../CustomButton';
import { ReactComponent as ReportIcon } from '../../assets/images/report.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';

const StyledDialog = styled(Dialog)(() => ({
  '& > .MuiDialog-container': {
    '& > .MuiDialog-paper': {
      position: 'relative',
      padding: '32px',
      width: '100%',
      maxWidth: '456px'
    }
  }
}));

export const CustomModal = ({
  opened,
  text,
  icon,
  modalClose,
  modalSubmit,
  cancelBtnName,
  submitBtnName,
  submitRoute,
  withoutSubmit,
  subText,
  ...props
}) => {
  return (
    <StyledDialog open={opened} onClose={modalClose} {...props}>
      <IconButton
        aria-label="close"
        onClick={modalClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[600]
        }}>
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '24px'
        }}>
        {icon || <ReportIcon />}
      </Box>
      <Typography
        variant="h2"
        align="center"
        sx={{
          width: '100%',
          marginBottom: '24px',
        }}>
        {text}
      </Typography>
      {subText && (
        <Typography
          variant="body1"
          align="center"
          sx={{
            width: '100%',
            marginBottom: '24px'
          }}>
          {subText}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center'
        }}>
        {cancelBtnName && (
          <CustomButton
            color="secondary"
            variant="contained"
            sx={{ marginRight: '16px' }}
            onClick={modalClose}>
            {cancelBtnName}
          </CustomButton>
        )}
        {!withoutSubmit && (
          <CustomButton
            component={submitRoute && RouterLink}
            to={submitRoute && submitRoute}
            variant="contained"
            onClick={modalSubmit}
            data-testid="SubmitButton"
          >
            {submitBtnName}
          </CustomButton>
        )}
      </Box>
    </StyledDialog>
  );
};

CustomModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  modalClose: PropTypes.func,
  modalSubmit: PropTypes.func,
  cancelBtnName: PropTypes.string,
  submitBtnName: PropTypes.string,
  submitRoute: PropTypes.string,
  withoutSubmit: PropTypes.bool,
  subText: PropTypes.string,
};
